module.exports = __webpack_public_path__ + "img/close.27c52fc5.png";